(()=>{'use strict';
const hero=document.querySelector('.gp-hero--outdoor');
const stage=hero?.querySelector('[data-hero-landing]');
const poster=hero?.querySelector('[data-hero-poster]');
const root=document.documentElement;
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
if(!hero||!stage||!poster||!root.classList.contains('gp-intro-enabled'))return;
let ended=false,animations=[];
const listeners=new AbortController();
const reset=()=>{
 if(ended)return;
 ended=true;
 clearTimeout(timeout);
 clearTimeout(window.gpIntroFallback);
 listeners.abort();
 root.classList.remove('gp-intro-enabled');
 hero.dataset.introState='complete';
 for(const animation of animations)animation.cancel();
 stage.remove();
};
const timeout=setTimeout(reset,2400);
const plate=new Image();
plate.decoding='async';
plate.src=stage.dataset.plate;
reduce.addEventListener('change',()=>{if(reduce.matches)reset()},{signal:listeners.signal});
document.addEventListener('visibilitychange',()=>{if(document.hidden)reset()},{signal:listeners.signal});
window.addEventListener('scroll',()=>{if(scrollY>100)reset()},{passive:true,signal:listeners.signal});
const product=new Image();
product.src=hero.querySelector('[data-product-detail]').getAttribute('href');
Promise.all([plate.decode(),poster.decode(),product.decode()]).then(()=>{
 if(ended)return;
 if(reduce.matches||document.hidden||location.hash||scrollY>100){reset();return}
 const rect=hero.getBoundingClientRect();
 if(rect.bottom<0||rect.top>innerHeight){reset();return}
 stage.querySelector('[data-landing-plate]').setAttribute('href',plate.src);
 stage.querySelectorAll('[data-landing-original]').forEach(image=>image.setAttribute('href',poster.currentSrc||poster.src));
 // A short, gravity-led placement. No elastic rebound or scale distortion.
 // The existing chews and contact shadow stay on the rock throughout.
 const drop=matchMedia('(max-width:760px)').matches?14:24;
 const bottle=stage.querySelector('[data-landing-bottle]').animate([
  {transform:`translateY(-${drop}px) rotate(-.16deg)`,offset:0,easing:'cubic-bezier(.55,0,.9,.55)'},
  {transform:'translateY(0) rotate(.05deg)',offset:.58,easing:'cubic-bezier(.16,1,.3,1)'},
  {transform:'translateY(-.65px) rotate(-.025deg)',offset:.73,easing:'ease-in-out'},
  {transform:'translateY(0) rotate(0)',offset:1}
 ],{duration:480,fill:'both'});
 clearTimeout(timeout);
 clearTimeout(window.gpIntroFallback);
 animations=[bottle];
 hero.dataset.introState='playing';
 // Both states use the same original scene. Switch only once the jar aligns.
 bottle.finished.then(reset).catch(reset);
}).catch(reset);
})();
